import { Grid, Box, Divider, Hidden } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { InvoiceStatus } from '../../common/enums/enums';
import { GenCurrency } from '../GenDataFormat';
import GenDataText from '../GenDataText';
import GenPaymentStatus from '../GenPaymentStatus';

const InvoiceContainer = ({ itemStatus, itemPrice, itemNumber }) => (
  <Grid
    sx={{
      p: { xs: 2, sm: 2, lg: 4 },
    }}
    container
    justifyContent="space-around"
  >
    <Grid item xs={6} sm={4} order={{ xs: 2, sm: 1 }}>
      <Grid item>{itemNumber}</Grid>
    </Grid>
    <Grid item xs={6} sm={4} order={{ xs: 1, sm: 2 }}>
      {itemStatus}
    </Grid>
    <Hidden smUp>
      <Grid item xs={6} sm={4} order={{ xs: 3, sm: 3 }}></Grid>
    </Hidden>
    <Grid item xs={6} sm={4} order={{ xs: 3, sm: 3 }}>
      {itemPrice}
    </Grid>
  </Grid>
);

const WOrderPaymentStatus = ({ data }) => {
  const { t } = useTranslation('workOrdersTable');

  return (
    <>
      {data?.isBilled && (
        <Box
          sx={{
            bgcolor: 'background.paper',
            p: { xs: 0, sm: 0, md: 4, lg: 4 },
            borderTop: '1px solid',
            borderColor: theme => theme.palette.divider,
          }}
        >
          {data?.invoices?.map(
            (invoice, index) =>
              invoice.status !== InvoiceStatus.CANCELED && (
                <Box key={`payment-status-${index}`}>
                  <InvoiceContainer
                    itemNumber={
                      <GenDataText
                        label={t('detail.paymentStatus.invoiceNumber')}
                        text={invoice.invoiceNumber}
                        direction="vertical"
                        alignItems="start"
                      />
                    }
                    itemStatus={
                      <GenDataText
                        label={t('detail.statusRow.statusLabel')}
                        text={
                          <GenPaymentStatus
                            amount={invoice.amount}
                            unpaid={invoice.unpaid}
                            status={invoice.status}
                            isInvoice={true}
                          />
                        }
                        direction="vertical"
                        alignItems="start"
                      />
                    }
                    itemPrice={
                      <GenDataText
                        label={t('detail.paymentStatus.totalPrice')}
                        text={<GenCurrency value={invoice.amount} />}
                        direction="vertical"
                        alignItems="start"
                      />
                    }
                  />
                  {index !== data.invoices.length - 1 ? <Divider /> : null}
                </Box>
              )
          )}
        </Box>
      )}
    </>
  );
};

export default WOrderPaymentStatus;
